export default __webpack_public_path__ + "static/media/SMS_Logo.f553d6e1.svg";